import { ArtifactType } from '@/models'
import * as joint from '@clientio/rappid'
import vuetify from '@/plugins/vuetify'

export default class ArtifactsCountPill extends joint.elementTools.Button {
  constructor(cellView: joint.dia.CellView, artifactType: ArtifactType) {
    super({
      className: 'ArtifactsCountPill',
      markup: [
        {
          tagName: 'circle',
          selector: 'button',
          attributes: {
            r: 15,
            fill: '#000000',
            cursor: 'pointer',
            stroke: vuetify.theme.themes.value.light.colors['grey-light'],
            'stroke-width': '2px',
          },
        },
        {
          tagName: 'text',
          selector: 'text',
          textContent: (
            artifactType.containerSearchArtifactCount ?? artifactType.artifactCount
          )?.toString(),
          attributes: {
            'font-size': 12,
            'text-anchor': 'middle',
            fill: '#FFFFFF',
            y: '0.3em', // Adjust this value to center vertically
            'ref-x': '50%', // Centered horizontally
          },
        },
      ],
      distance: 0,
      offset: {
        x: 0,
        y: 0,
      },
    })
  }
}
